// input amount
export type InputAmount = {
  amount: string;
  contractAddress: string;
};

export enum FeeLevel {
  Slow = 'slow',
  Middle = 'middle',
  Fast = 'fast',
}

export type GasPriceDetail = {
  priority: string;
  gasPrice: string;
  gasFee: string;
  gasFeeMax: string;
  avgTime: string;
};

export type GasFeeInfo = {
  gasOrigin: string;
  gasMax: string;
  l1Gas: string;
  gasLimit: string;
  gasPrice: string;
  baseFee: string;
  priority: string;
  slow: GasPriceDetail;
  middle: GasPriceDetail;
  fast: GasPriceDetail;
};
export type CoinDetailJson = {
  chainId?: string | number;
  chainCode: string;
  iconDayUrl: string;
  iconNightUrl: string;
  symbol: string;
  price: string;
};
export type CoinInfo = {
  contractAddress: string;
  volume: string;
  chainId?: number | string;
  decimal?: number;
  iconDayUrl?: string;
  iconNightUrl?: string;
  symbol?: string;
  price: string;
  amount: string;
  quoteAmount: string;
  coinDetailJson?: CoinDetailJson;
  router?: string;
  minOutAmount?: string;
  chainCode?: string;
};

export type CoinInfoStore = Record<string, CoinInfo>;

export enum ApproveFailType {
  CANCEL = 1,
  UN_KNOWN = 2,
}

export type PriceInfo = {
  amount: string;
  value: string;
};

export enum OperationTab {
  Stake = 'Stake',
  Account = 'Account',
  Airdrop = 'Airdrop',
}

export type CommonWalletInfo = {
  walletAddress: string;
  chainId: number;
  pubKey?: string;
};

export enum DataStatus {
  Loading,
  Error,
  Empty,
  Normal,
}
